/**
 * @fileoverview Agent definition for world-organization-ideation-v3.
 *
 * This agent generates ideas for organizations (factions, nations, institutions)
 * that could appear in the story world.
 *
 * @category world-building.organizations.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-organization-ideation-v3',
  kind: 'primitive',
  name: 'World Organization Ideation',
  description: 'Generates ideas for organizations (factions, nations, institutions) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.organizations.creation',
    usedBy: ['use-world-organization-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-organization-details-ideation-v3',
      'world-organization-details-generator-v3',
    ],
  },
};
